import {useEffect, useState} from "react";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading} from "../../../components/template/architecture";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {BreadCrumbs} from "../../../components/open/pages";
import {ThinClassIcon, ThinPrintIcon, TomansIcon} from "../../../components/icons/material-icons";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {SelectClassModal} from "../classes/select-class-modal";
import {Link} from "react-router-dom";

interface studentsWithBudget{
    id:number,
    name:string,
    national:string,
    class:string,
    budget:number,
}

export const AdminsStoreListStudentsWithBudget = () => {
    const [classSelected, setClassSelected] = useState({
        id: 0,
        title: '',
    });
    const [classModal, setClassModal] = useState(false);
    const [data, setData] = useState({
        loaded: false,
        list: [] as studentsWithBudget[],
    });
    const fetchList = (classId:number) => {
        PostJSON(
            Apis.server + '/core/admins/store/with-budget',
            {
                classId: classId,
            },
            true,
            (d: {
                result: string,
                reason: string | undefined,
                list: studentsWithBudget[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setData({
                    list: d.list === null ? [] : d.list,
                    loaded: true,
                });
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "دانش‌آموزان دارای موجودی | اتوماسیون";
        fetchList(0);
    }, []);
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'بوفه', url: '/admins/store'},
                {title: 'دانش‌آموزان دارای موجودی', url: '/admins/store/with-budget'},
            ]}/>
            {
                data.loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>دانش‌آموزان دارای موجودی</b>
                                <div className="d-inline-flex align-items-center" style={{gap: 10}}>
                                    <button onClick={() => setClassModal(true)}>
                                        <ThinClassIcon/>
                                        <span>{classSelected.id > 0 ? classSelected.title : 'همه کلاس‌ها'}</span>
                                    </button>
                                    <button onClick={() => window.open(`/print/admins/store/with-budget/${classSelected.id}`)}>
                                        <ThinPrintIcon/>
                                        <span>پرینت</span>
                                    </button>
                                </div>
                            </div>
                            <table className="table open-table table-stripped table-bordered table-hover"
                                   style={{display: 'table!important', border: 0}}>
                                <thead>
                                <tr>
                                    <th>ردیف</th>
                                    <th>دانش‌آموز</th>
                                    <th>کدملی</th>
                                    <th>کلاس</th>
                                    <th>موجودی</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    (data.list === null ? [] : data.list).map((p, i) =>
                                        <tr key={"K39Erc12EnSss" + i}>
                                            <td>{StringDigitsConvertToPersian(i + 1)}</td>
                                            <td>
                                                <Link to={`/admins/students/view/${p.id}`}>
                                                    {p.name}
                                                </Link>
                                            </td>
                                            <td>{StringDigitsConvertToPersian(p.national)}</td>
                                            <td>{p.class === '' ? 'نامشخص' : p.class}</td>
                                            <td>
                                                <span>{CurrencyFormat(p.budget)}<TomansIcon/></span>
                                            </td>
                                        </tr>
                                    )
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    : null
            }
            <SelectClassModal
                active={classModal}
                closeHandler={() => setClassModal(false)}
                onSelected={(id: number, title: string) => {
                    // ShowProgressLoading();
                    setClassSelected({
                        title: "کلاس " + title,
                        id: id,
                    });
                    window.scrollTo({top: 0, behavior: 'smooth'});
                    fetchList(id);
                }}
            />
        </>
    );
};